import { zipCodeCityApis } from '@apis/zipCodeCityApis';
import { useQuery } from '@hooks/useQuery';

export const useZipCodeCityByCity = ({
  city,
  enable_zh = false,
}: {
  city?: string;
  enable_zh?: boolean;
}) => {
  return useQuery(
    ['/zipcode-city/zipcode/{city}', { city, enable_zh }],
    () =>
      zipCodeCityApis
        .get('/zipcode-city/zipcode/{city}/', {
          path: { city: city! },
          query: { enable_zh },
        })
        .then((r) => r['200']),
    {
      enabled: Boolean(city),
    },
  );
};
